var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "rotate(180deg)"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#df4040d9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L14.375 5.625H5.625L10 10Z",
    stroke: "#df4040d9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63281 3.125H15.365C15.4887 3.125 15.6095 3.16166 15.7123 3.23033C15.8151 3.29901 15.8952 3.39662 15.9425 3.51082C15.9898 3.62503 16.0022 3.75069 15.978 3.87193C15.9539 3.99317 15.8944 4.10453 15.807 4.19194L9.99893 10L4.19087 4.19194C4.10346 4.10453 4.04394 3.99317 4.01982 3.87193C3.99571 3.75069 4.00808 3.62503 4.05539 3.51082C4.10269 3.39662 4.1828 3.29901 4.28558 3.23033C4.38836 3.16166 4.5092 3.125 4.63281 3.125Z",
    stroke: "#df4040d9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63281 16.875H15.365C15.4887 16.875 15.6095 16.8383 15.7123 16.7697C15.8151 16.701 15.8952 16.6034 15.9425 16.4892C15.9898 16.375 16.0022 16.2493 15.978 16.1281C15.9539 16.0068 15.8944 15.8955 15.807 15.8081L9.99893 10L4.19087 15.8081C4.10346 15.8955 4.04394 16.0068 4.01982 16.1281C3.99571 16.2493 4.00808 16.375 4.05539 16.4892C4.10269 16.6034 4.1828 16.701 4.28558 16.7697C4.38836 16.8383 4.5092 16.875 4.63281 16.875Z",
    stroke: "#df4040d9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.625H14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredIcon);
export default __webpack_public_path__ + "static/media/expiredIcon.de331bcdcbef23e1d390156c4c1cf7fa.svg";
export { ForwardRef as ReactComponent };